import React, { Component } from "react";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import "./style.scss";
import classNames from "classnames";
import Table from "../../react-components/table";
import Heading from "../../elements/heading";
import IconLinkEle from "../../elements/icon-link";
import api from "../../utils/api";
export default class OpenPositions extends Component {
  constructor(props, context) {
    super(props, context);
    const { fields } = this.props;
    const { size, CTA } = fields;
    let IconLink = ( CTA && CTA.length )
      ? CTA[0].fields
      : {};
    IconLink.callback = () => this.loadMore();
    this.state = {
      tableData: {
        fields: {
          headings: [],
          rows: [],
          firstColumnIsLeadColumn: { value: true },
          sortIsEnabled: { value: true },
          noRowsBody: { value: null }
        }
      },
      // currentPage: Math.floor(
      //   this.props.fields.tableData.rows.length / this.props.fields.pageSize
      // ),
      currentPage: 1,
      totalItemsCount: 10,
      apistate: true,
      pageSize: Number((size && size.value) || 10000),
      IconLink: IconLink
    };
  }

  loadMore = event => {
    // let currentPage= this.state.currentPage + 1
    // this.setState({ currentPage: currentPage });
    this.getDate();
    //todo when backend exists
  };
  getDate() {
    let model = this.props.fields ? this.props.fields : {};
    if (!this.state.apistate) {
      return false;
    }
    this.setState({
      apistate: false
    });
    api.pages
      .openposition({
        page: this.state.currentPage,
        size: this.state.pageSize
      })
      .then(res => {
        let tableData = this.state.tableData;
        let rows = tableData.fields.rows;
        let IconLink = this.state.IconLink;
        let objkey = res.items.length ? Object.keys(res.items[0]) : [];
        let headerArr = [];
        objkey.forEach((item, index) => {
          let obj = {
            fields: { text: { value: item } }
          };
          if (item !== "url") {
            headerArr.push(obj);
          }
        });
        tableData.fields.headings = [...headerArr];
        res.items.forEach((item, index) => {
          let objitem = [];
          objkey.forEach(it => {
            let obj = { fields: { text: { value: item[it] } } };
            if (it !== "url") {
              objitem.push(obj);
            }
          });
          let obj = {
            fields: {
              link: { value: { href: item.url } },
              items: objitem
            }
          };
          rows.push(obj);
        });
        if (res.total >= rows.length) {
          if (model.CTA.length) {
            IconLink.isDisabled = {
              value: rows.length === this.state.totalItemsCount
            };
          }
          if (!tableData.fields.rows.length) {
            tableData.fields.noRowsBody.value = <p>No available jobs at the moment, please check in later.</p>
          }
          this.setState({
            currentPage: this.state.currentPage + 1,
            tableData: tableData,
            IconLink: IconLink,
            totalItemsCount: res.total,
            apistate: true
          });
        }
      })
      .catch(res => {
        console.log(res);
      });
  }
  componentDidMount(props) {
    this.getDate();
  }
  render() {
    if (!this.props.fields) return null;
    let model = this.props.fields ? this.props.fields : {};
    const { headingBody, headingType, body, CTA } = model;
    const { tableData, totalItemsCount, pageSize, IconLink } = this.state;
    const morePrimaryButtonClasses = classNames("more-jobs");

    return (
      <div
        className={"open-positions grid"}
        datasourceid={this.props.rendering.dataSource}
      >
        {headingBody && (
          <Heading
            className={"title show-on-scroll"}
            {...{
              type: headingType,
              html: headingBody
            }}
          />
        )}

        {body && body.value && (
          <RichText tag="div" className={"body-text"} field={body} />
        )}

        <div className={"table-container"}>
          {tableData && <Table {...tableData} />}
        </div>
        {totalItemsCount >= tableData.fields.rows.length &&
          totalItemsCount > pageSize &&
          CTA.length > 0 && (
            <IconLinkEle className={morePrimaryButtonClasses} {...IconLink} />
          )}
      </div>
    );
  }
}
